// Thin wrappers around the public Duet Parse Cloud functions used by the
// reservation portals. They mirror the axios + App Check pattern used inline
// for `v1_webapp_public_create_new_reservation`.

import axios from 'axios';
import Firebase from './Firebase';

// Validate/format a phone number via the public Twilio Lookup cloud function.
// `country_code` is intentionally omitted — the endpoint defaults to US.
//
// Returns the `data` payload: { valid, e164_format, national_format,
// country_code, phone_type, carrier_name }. Returns null if the request fails
// (e.g. network/App Check error) so callers can treat it as "not validated".
export const checkPhoneNumberFormat = async (phoneNumber) => {
	if (!phoneNumber) return null;

	try {
		const functionName = "v1_webapp_public_check_phone_number_format";
		const appCheckToken = await Firebase.getAppCheckToken();

		const response = await axios.post(
			`${process.env.REACT_APP_DUET_SERVER_URL}/${functionName}`,
			{ phone_number: phoneNumber },
			{
				headers: {
					'X-Parse-Application-Id': process.env.REACT_APP_DUET_APP_ID,
					'X-Firebase-AppCheck': appCheckToken,
					'Content-Type': 'application/json',
				},
			}
		);

		// Parse REST wraps cloud-function output in `{ result: ... }`; fall back
		// to the raw body in case the server returns the envelope directly.
		const envelope = response?.data?.result ?? response?.data;

		return envelope?.data ?? null;
	} catch (error) {
		console.log(error);
		return null;
	}
};
